import React from 'react';
import Toggle, { type ToggleProps } from './Toggle';

export type ToggleFieldProps = ToggleProps;

/** Inline toggle + label row; optional hint renders below the label text. */
export default function ToggleField(props: ToggleFieldProps) {
  return <Toggle {...props} />;
}

export { ToggleField as ScoutlyToggleField };
